import { render, staticRenderFns } from "./TimetableCardHistory.vue?vue&type=template&id=5a14fa2f&scoped=true"
import script from "./TimetableCardHistory.vue?vue&type=script&lang=js"
export * from "./TimetableCardHistory.vue?vue&type=script&lang=js"
import style0 from "./TimetableCardHistory.vue?vue&type=style&index=0&id=5a14fa2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a14fa2f",
  null
  
)

export default component.exports